import type { FileChanges, FileUpdate } from '@/infra/sse/conversation/payloads'

export function buildFileChanges(
  toolName: string,
  toolInput: Record<string, unknown>,
  toolResponse: Record<string, unknown>,
): FileChanges | null {
  switch (toolName) {
    case 'Write':
      return buildFromWrite(toolInput, toolResponse)
    case 'Edit':
      return buildFromEdit(toolInput, toolResponse)
    default:
      return null
  }
}

export function getFileName(targetPath: string): string {
  const parts = targetPath.split('/').filter(Boolean)
  return parts.at(-1) ?? 'unknown file'
}

function extractFilePath(toolInput: Record<string, unknown>): string {
  return typeof toolInput['file_path'] === 'string' ? toolInput['file_path'] : ''
}

function buildFromWrite(
  toolInput: Record<string, unknown>,
  toolResponse: Record<string, unknown>,
): FileChanges {
  return {
    targetPath: extractFilePath(toolInput),
    newContent: typeof toolResponse['content'] === 'string' ? toolResponse['content'] : null,
    updates: null,
  }
}

function buildFromEdit(
  toolInput: Record<string, unknown>,
  toolResponse: Record<string, unknown>,
): FileChanges {
  const structuredPatch = toolResponse['structuredPatch']
  const updates: readonly FileUpdate[] | null = Array.isArray(structuredPatch)
    ? structuredPatch
        .filter(
          (hunk): hunk is Record<string, unknown> => typeof hunk === 'object' && hunk !== null,
        )
        .map(
          (hunk): FileUpdate => ({
            oldStart: Number(hunk['oldStart'] ?? 0),
            oldLines: Number(hunk['oldLines'] ?? 0),
            newStart: Number(hunk['newStart'] ?? 0),
            newLines: Number(hunk['newLines'] ?? 0),
            lines: Array.isArray(hunk['lines']) ? hunk['lines'].map(String) : [],
          }),
        )
    : null

  return {
    targetPath: extractFilePath(toolInput),
    newContent: null,
    updates,
  }
}
